import TYPES from '@/types';

import Vue from 'vue';

import { getGoalIconPath } from '@/vue-app/utils/goal-icon-path';

// Domain
import {
  ManageTrackingInvestorGoalStateManager,
} from '@/modules/flagship/investor-goal/investor_goal/domain/state/manage-tracking-investor-goal-state-manager';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class InvestorGoalMovementsDialogViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  @Inject(TYPES.MANAGE_TRACKING_INVESTOR_GOAL_STATE_MANAGER)
  readonly manage_tracking_investor_goal_state_manager!: ManageTrackingInvestorGoalStateManager;

  readonly i18n_namespace = 'components.goals-dashboard.linked-goals.movements';

  readonly view: Vue;

  is_loading = false;

  styles = {
    color_card: '',
    color_title: 'primary--text',
    color_divider: '',
    color_icon: 'sky-blue',
    color_btn: 'white--text',
  }

  icon_path = '';

  icon_max_width = 30;

  manage_tracking_investor_goal_state = this
    .manage_tracking_investor_goal_state_manager.state;

  constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  changeStyles = () => {
    if (this.manage_tracking_investor_goal_state.strategy.name.includes('Moderado')) {
      this.styles.color_card = 'primary';
      this.styles.color_title = 'white--text';
      this.styles.color_divider = 'white';
      this.styles.color_icon = 'white';
      this.styles.color_btn = 'accent--text';
    }
  }

  loadIcon = () => {
    this.icon_path = getGoalIconPath(
      this.manage_tracking_investor_goal_state.icon.file_id,
      this.manage_tracking_investor_goal_state.icon.name,
      this.manage_tracking_investor_goal_state.icon.updated_at.toString(),
    );
  }

  initialize = async () => {
    this.changeStyles();
    this.loadIcon();
  }
}
